export const actionTypes = {
  SET_APPSETTINGS: 'SET_APPSETTINGS',
};

export const setAppsettings = data => ({
  type: actionTypes.SET_APPSETTINGS,
  payload: data,
});
